module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/cakes-68af2ae5d90acbaf51e11ad84abceb77.webp";